import { Box, Stack, useTheme } from '@mui/material'
import { Toolbar } from '@mui/x-data-grid'
import type { ReactNode } from 'react'

interface TableToolbarProps {
  filters?: ReactNode
  actions?: ReactNode
  bulkActions?: ReactNode
}

/**
 * This component is an extension of GridToolbarContainer from Material UI Data Grid. It applies some style
 * modifications like:
 *
 * - Min height of the toolbar is 64px
 * - Space between filters and actions is 8px.
 * - Filters and actions are aligned to the left and right respectively.
 */
const GridToolbar = ({ filters, actions, bulkActions }: TableToolbarProps) => {
  const theme = useTheme()

  return (
    <Box>
      <Toolbar
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          padding: '6px 10px 0px',
          minHeight: '64px',
          gap: theme.spacing(1),
        }}
      >
        <Stack direction="row" sx={{ alignItems: 'stretch', gap: 1 }}>
          {filters}
        </Stack>

        <Stack direction="row" sx={{ alignItems: 'stretch', gap: 1 }}>
          {actions}
        </Stack>
      </Toolbar>

      {bulkActions && <Stack>{bulkActions}</Stack>}
    </Box>
  )
}

export default GridToolbar
